import { Box, Button, ButtonAppearance, Heading, Text } from '@bechtel/gds';
import { useLocation, useNavigate } from 'react-router';
import { ActionContent, ErrorBoundary, ItemListHeader } from '~/components';
import { CatalogInfo } from '~/components/catalog-info';
import { ImageFallback } from '~/components/image-fallback';
import { NonCatalogImage, NonCatalogInfo } from '~/components/non-catalog/list-item';
import { getFormatedDate } from '~/utilities';
import {
  ItemCountStyled,
  OrderConfirmationBodyHeaderStyled,
  OrderConfirmationBodyStyled,
  OrderConfirmationContainerStyled,
  OrderConfirmationHeaderStyled,
  OrderConfirmationSideSheetStyled,
  OrderConfirmationStyled,
} from './styled';

// interface ToolOrderConfirmationProps {
//   toolOrder: ToolOrder;
// }

export const ToolOrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toolOrder = location.state?.toolOrder;
  // if (!toolOrder) {
  //   navigate('/reservations');
  //   return <></>;
  // }

  return (
    <ErrorBoundary>
      <OrderConfirmationSideSheetStyled visible={true}>
        <OrderConfirmationContainerStyled>
          <OrderConfirmationStyled>
            <OrderConfirmationHeaderStyled>
              <Box mb={{ sm: '600' }} justifyContent={{ sm: 'center' }}>
                <Text color="green.400" size="500">
                  Order Success!
                </Text>
              </Box>
              <div>
                <Heading color="blue.800" family={'openSansSemiBold'} size="700">
                  #&nbsp;{toolOrder?.orderNumber}
                </Heading>
              </div>
              <div>
                <Text color="blue.800" size="300">
                  Required On: {getFormatedDate(toolOrder?.requiredStartDate)}
                </Text>
              </div>
            </OrderConfirmationHeaderStyled>
            <OrderConfirmationBodyHeaderStyled>
              <ItemListHeader alignItems={{ sm: 'center' }}>
                <Box flexGrow={{ sm: '1' }}>
                  <Text size="300">Items</Text>
                </Box>
                <Text size="300">Qty.</Text>
              </ItemListHeader>
            </OrderConfirmationBodyHeaderStyled>
            <OrderConfirmationBodyStyled>
              {toolOrder?.toolOrderCatalogs.map((toolOrderCatalogItem) => {
                const toolCatalog = toolOrderCatalogItem.toolCatalog;

                return (
                  <Box key={toolOrderCatalogItem.id} px={{ sm: '500' }} py={{ sm: '300' }}>
                    {toolCatalog && (
                      <Box style={{ width: '100%' }}>
                        <Box p={{ sm: '400' }} style={{ paddingLeft: '0px' }}>
                          <ImageFallback
                            src={toolCatalog?.toolCatalogImageUrl}
                            fallbackName={toolCatalog?.toolCategory?.name}
                          />
                        </Box>
                        <Box
                          flexDirection={{ sm: 'column' }}
                          style={{ flex: '1 1 0%' }}
                          pr={{ sm: '900' }}
                          gap={{ sm: '300' }}
                        >
                          <CatalogInfo
                            barCode={toolCatalog && toolCatalog.bscnPartNumber ? toolCatalog.bscnPartNumber : ''}
                            description={toolCatalog && toolCatalog.name ? toolCatalog.name : ''}
                            isSerialized={
                              ['Individual', 'Equipment'].includes(toolCatalog?.inventoryType ?? '') ? true : false
                            }
                            uomAbbreviation={toolCatalog?.uom ? toolCatalog.uom.abbreviation : ''}
                          />
                        </Box>
                      </Box>
                    )}
                    {!toolCatalog && (
                      <NonCatalogInfo
                        nonCatalogDescription={toolOrderCatalogItem.nonCatalogDescription || ''}
                        nonCatalogUomId={toolOrderCatalogItem?.nonCatalogUomId ?? 0}
                      >
                        <NonCatalogImage />
                      </NonCatalogInfo>
                    )}
                    <ItemCountStyled>
                      <Text color="blue.800" size="400">
                        {toolOrderCatalogItem.quantity}
                      </Text>
                    </ItemCountStyled>
                  </Box>
                );
              })}
            </OrderConfirmationBodyStyled>
          </OrderConfirmationStyled>
          <Box gap={{ sm: '500' }} style={{ minWidth: '420px' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={() => navigate('/reservations')}>
              <Text weight="600" family={'openSansSemiBold'}>
                Back to Reservations
              </Text>
            </Button>
            <Button onClick={() => navigate('/reservations/new')}>
              <ActionContent
                icon="plus"
                label="Reserve More Tools"
                labelFamily={'openSansSemiBold'}
                labelWeight="600"
                labelSize="400"
                fillColor="white"
              />
            </Button>
          </Box>
        </OrderConfirmationContainerStyled>
      </OrderConfirmationSideSheetStyled>
    </ErrorBoundary>
  );
};
